import { render } from "./Marquee.vue?vue&type=template&id=6742eb4c&scoped=true"
const script = {}

import "./Marquee.vue?vue&type=style&index=0&id=6742eb4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6742eb4c"]])

export default __exports__